export const INDEX = {
    role: 'editor',
    route: '',
    name: 'index'
};

export const DASHBOARD = {
    role: 'editor',
    route: '/dashboard',
    name: 'dashboard'
};

export const LOGIN = {
    route: '/login',
    name: 'login'
};

export const ARTICLE_EDITOR = {
    role: 'editor',
    route: '/article/:slug',
    name: 'article-editor'
};

export const ARTICLE_CREATOR = {
    role: 'editor',
    route: '/article',
    name: 'article-creator'
};

export const ARTICLES = {
  role: 'editor',
  route: '/articles',
  name: 'articles'
};


export const USER_EDITOR = {
    role: 'super_user',
    route: '/user/:userId',
    name: 'user-editor'
};

export const USER_CREATOR = {
    role: 'super_user',
    route: '/user',
    name: 'user-creator'
};

export const USERS = {
    role: 'super_user',
    route: '/users',
    name: 'users'
};

export const FORBIDDEN = {
    route: '/404'
};




// WEBPACK FOOTER //
// ./src/router/routes.js